import { Column } from '@components';
import { Box, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';

type TableHeaderProps = {
  headerColumns: Array<Column>;
};

const StyledHeaderCell = styled(Box)`
  display: none;
  ${breakpoints.up('md')} {
    display: block;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 160%;
    color: #1c1c1c;
    padding: 12px;
    overflow: hidden;
  }
`;

export const TableHeader = ({ headerColumns }: TableHeaderProps) => {
  return (
    <>
      {headerColumns?.map((column) => (
        <StyledHeaderCell key={column.key}>{column.name}</StyledHeaderCell>
      ))}
    </>
  );
};
